<template>
	<div class="col-lg-8">
		<div class="tile">
			Страница не найдена
		</div>
	</div>
</template>